define('presentation/reactivation/viewModels/reactivationSuccessViewModel',[
    'businessServices/authentication/authenticationManager',
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/authentication/sessionWorkflowFlags',
    'common/promises/promiseFactory',
    'plugins/router',
    'presentation/reactivation/facades/reactivationPlansFacade',
    'presentation/common/window/windowControl',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('plugins/router');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
        const _sessionWorkflowFlags = require('businessServices/authentication/sessionWorkflowFlags');
        const _windowControl = require('presentation/common/window/windowControl');

        let _facade = null;

        const _getAccountPlan = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getAccountPlan()
                    .fail(promise.reject)
                    .done((accountPlan) => {
                        self.telephonyPackage(accountPlan.telephonyPackage);
                        self.liveReceptionistPackage(accountPlan.liveReceptionistPackage);
                        self.webChatPackage(accountPlan.webChatPackage);
                        self.outboundCallingPackage(accountPlan.outboundCallingPackage);
                        promise.resolve();
                    });
            });
        };

        self.isCompositionComplete = ko.observable(false);
        self.telephonyPackage = ko.observable(null);
        self.liveReceptionistPackage = ko.observable(null);
        self.webChatPackage = ko.observable(null);
        self.outboundCallingPackage = ko.observable(null);

        self.shouldDisplayAgentBypassButton = ko.pureComputed(() => {
            return _sessionAccountInfo.isImpersonating();
        });

        self.showOnboardingMessage = ko.pureComputed(() => {
            return self.liveReceptionistPackage() !== null || self.webChatPackage() !== null || self.outboundCallingPackage() !== null;
        });

        self.openOnboardingAppointment = () => {
            _windowControl.onOpenOnboardingAppointment();
        };

        self.onContinue = () => {
            _router.navigate(_navigationConfiguration.loginLandingPageUrl);
        };

        self.onAgentBypass = () => {
            _sessionWorkflowFlags.hasBypassedClosedAccount(true);
            _sessionWorkflowFlags.hasBypassedPastDueBalance(true);
            _router.navigate(_navigationConfiguration.loginLandingPageUrl);
        };

        self.onSignInToWebApp = () => {
            _router.navigate(_navigationConfiguration.loginLandingPageUrl);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/reactivation/facades/reactivationPlansFacade');
            _facade = new FacadeConstructor();
            _facade.init();

            return _initialize();
        };

        const _initialize = () => {
            _getAccountPlan();

            return _promiseFactory.wait();
        };
    };
});
